import React from "react";
import styles from "./kamaGameCard.module.css";

import HotLevelIcon from "../../desafiosPicantes/hotLevelIcon";

import borda_branca from "../../../assets/images/games/kamasutra/borda-branca.png";
import borda from "../../../assets/images/games/kamasutra/borda.png";

export default function KamaGameCard({
  borderSize,
  image,
  number,
  hotLevel,
  className,
  onClick,
  Back,
  Background,
  style,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.card} ${className || ""}`}
      style={style}
    >
      <div className={styles.front}>
        <div
          className={styles.cardContent}
          style={{
            borderImageSource: `url(${borda})`,
            borderImageWidth: borderSize ? `${borderSize}px` : undefined,
          }}
        >
          {Background ? (
            <div>
              <div className="absolute top-0 left-0 w-full h-full">
                <Background />
              </div>
            </div>
          ) : (
            ""
          )}
          {number !== undefined ? (
            <div className="mt-2">
              <h2 className="text-4xl font-black text-[#F3B2B4]">{number}</h2>
            </div>
          ) : null}
          <div className="flex-1 flex justify-center items-center">
            <div className="absolute top-0 left-0 h-full ms-1 me-1">
              <img className={styles.cardImage} src={image} alt="" />
            </div>
          </div>
          {hotLevel !== undefined ? (
            <div className="absolute w-full h-full flex items-end">
              <div className="flex items-center justify-center ms-[4.5rem] me-[4.5rem]">
                <div className="flex justify-around mt-5 mb-5 max-h-10">
                  {[1, 2, 3, 4, 5].map((i) => {
                    return (
                      <HotLevelIcon
                        activeColor="#FF5B68"
                        inactiveColor="#E2E2E2"
                        key={i}
                        size={22}
                        className="pe-1"
                        active={hotLevel >= i}
                      />
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.back}>
        <div
          className={styles.cardContent}
          style={{
            borderImageSource: `url(${borda_branca})`,
            borderImageWidth: borderSize ? `${borderSize}px` : undefined,
          }}
        >
          {Back ? <Back /> : ""}
        </div>
      </div>
    </button>
  );
}
